// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"502":"ucare-panel-chunk","868":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"331":"b084ff96","491":"2aa459c7","502":"a5706403","609":"b5ebb684","868":"5653acc1"}[chunkId] + ".chunk.js";
};